// extracted by mini-css-extract-plugin
export var active = "DesktopLinkBar-module--active--9ffd8";
export var contained = "DesktopLinkBar-module--contained--049ed";
export var linkbar = "DesktopLinkBar-module--linkbar--d79e8";